import React, { ReactNode, useRef, useState } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import { default as BootstrapTooltip } from 'react-bootstrap/Tooltip';
import { InfoCircleFill } from 'react-bootstrap-icons';

interface Props {
    title: ReactNode;
}

const Tooltip: React.FC<Props> = ({ title }: Props) => {
    const [show, setShow] = useState(false);
    const spanRef = useRef(null);

    return (
        <>
            <span
                ref={spanRef}
                className="ml-1"
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
            >
                <InfoCircleFill />
            </span>
            <Overlay
                target={spanRef.current}
                show={show}
                placement="right"
                container={undefined}
                onEnter={undefined}
                onEntered={undefined}
                onEntering={undefined}
                onExit={undefined}
                onExited={undefined}
                onExiting={undefined}
                onHide={undefined}
                popperConfig={undefined}
                rootClose={undefined}
                rootCloseEvent={undefined}
                transition={undefined}
            >
                {props => (
                    <BootstrapTooltip id="overlay-tooltip" {...props}>
                        {title}
                    </BootstrapTooltip>
                )}
            </Overlay>
        </>
    );
};

export default Tooltip;
